import React from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss"
import { useIntl } from "react-intl";

// shippingMethod 下面的
export const QuickShippingTxt = props => {
    useStyles(classes)
    const {clickHandle, htmlValue, isCart} = props
    const Intl = useIntl()

    return <div className={`${classes.QuickShippingTipBox} ${classes.QuickShippingTxt} ${isCart && classes.QuickShipping}`}>
        <span className={classes.QuickShippingTipLogo}>{`'${Intl.formatMessage({id: 'quick_ship', defaultMessage:'QuickShip'})}'`}</span>
        <span dangerouslySetInnerHTML={{__html: htmlValue}}></span>
        {clickHandle && <span className={classes.Ask} onClick={clickHandle}>?</span>}
    </div>
}

// 尺码下面的
const QuickShippingTip = props => {
    useStyles(classes)
    const {overseaSizeList} = props
    const Intl = useIntl()

    return <div className={classes.QuickShippingTipBox}>
        <span className={classes.QuickShippingTipLogo}>{Intl.formatMessage({id: 'quick_ship', defaultMessage:'QuickShip'})}</span>
        <span>{`${overseaSizeList?.join(',')} ${Intl.formatMessage({id: 'eligible_for_quick_ship', defaultMessage:'are eligible for QuickShip'})}`}</span>
    </div>
}

export default QuickShippingTip